const getLanguage = (locale)=>{
    const [languageCode] = locale.split('-');
    return languageCode;
};

export { getLanguage };
//# sourceMappingURL=get-language.js.map
